import { c as _c } from "react/compiler-runtime";
import { type MessageComposerHandle } from '@precis-digital/kurama/MessageLayout';
import { useEffect, useRef, type RefObject } from 'react';
import { useCopilot } from 'shared/context/CopilotContext';

/**
 * Focuses the drawer composer whenever the Copilot sidenav opens,
 * regardless of how it was opened (nav button, keyboard shortcut, etc.).
 * A drawer restored already-open from the URL on page load is not focused: nobody asked for it.
 */
export const useFocusComposerWhenDrawerOpens = composerRef => {
  const $ = _c(4);
  const {
    isCopilotOpen
  } = useCopilot();
  const skipRestoredOpenRef = useRef(isCopilotOpen);
  let t0;
  let t1;
  if ($[0] !== composerRef || $[1] !== isCopilotOpen) {
    t0 = () => {
      if (!isCopilotOpen) {
        skipRestoredOpenRef.current = false;
        return;
      }
      if (skipRestoredOpenRef.current) {
        skipRestoredOpenRef.current = false;
        return;
      }
      const timeoutId = window.setTimeout(() => {
        composerRef.current?.focus();
      }, 0);
      return () => {
        window.clearTimeout(timeoutId);
      };
    };
    t1 = [isCopilotOpen, composerRef];
    $[0] = composerRef;
    $[1] = isCopilotOpen;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};